import { Alert, Button, Checkbox, Form, Input } from "antd"
import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import apiClient from "../../Utils/apiClient"
import { LockOutlined, UserOutlined } from "@ant-design/icons"
import AuthShell from "../../Layout/AuthShell"

const Login = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const resetNotice = location.state?.passwordReset

  const onFinish = async (values) => {
    const payload = { email: values.useremail, password: values.password }
    setLoading(true)
    setError("")
    try {
      const res = await apiClient("auth/login", "POST", payload, {
        refresh: false,
      })

      if (res.success) {
        if (values.remember) {
          try {
            localStorage.setItem("dm_remember_email", values.useremail || "")
          } catch (_) {}
        } else {
          try {
            localStorage.removeItem("dm_remember_email")
          } catch (_) {}
        }
        if (res.twoFAEnabled) {
          navigate("/twoFactorAuth")
        } else {
          navigate("/twoFactorAuthSetup")
        }
      } else {
        setError(res?.message || "Email or password is incorrect.")
      }
    } catch (err) {
      setError("Could not reach the sign-in service. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  let remembered = ""
  try {
    remembered = localStorage.getItem("dm_remember_email") || ""
  } catch (_) {}

  return (
    <AuthShell
      title="Welcome Back!"
      subtitle="Sign in to your MDM Dashboard."
      badge="Secure console access"
      steps={["Credentials", "Verify", "Console"]}
      activeStep={1}
    >
      <Form
        className="auth-form"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        requiredMark={false}
        initialValues={{
          useremail: remembered,
          remember: Boolean(remembered),
        }}
      >
        {resetNotice ? (
          <Alert
            type="success"
            showIcon
            message="Password updated. Sign in with your new password."
            className="mb-3"
          />
        ) : null}
        {error ? (
          <Alert
            type="error"
            showIcon
            message={error}
            className="mb-3"
            closable
            onClose={() => setError("")}
          />
        ) : null}

        <Form.Item
          label="Email or User Name"
          name="useremail"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input
            size="large"
            prefix={<UserOutlined className="auth-input-icon" />}
            placeholder="you@company.com"
            autoComplete="username"
          />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter your password" }]}
        >
          <Input.Password
            size="large"
            prefix={<LockOutlined className="auth-input-icon" />}
            placeholder="Enter your password"
            autoComplete="current-password"
          />
        </Form.Item>

        <div className="auth-link-row auth-link-row--split">
          <Form.Item name="remember" valuePropName="checked" className="mb-0">
            <Checkbox>Remember Me</Checkbox>
          </Form.Item>
          <Button
            type="link"
            className="auth-forgot p-0"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </Button>
        </div>

        <Form.Item className="mb-0">
          <Button
            className="auth-submit"
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
          >
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </AuthShell>
  )
}

export default Login
